import { Route, Switch } from 'react-router-dom';
import { BASE_PATHS } from '@common/constants/AppConstants';
import RentalManagerApp from '@rental-manager/pages/App';
import RenterHubApp from '@renter-hub/pages/App';
import DevApp from '@dev-app/App';
import { RenterAuthProvider } from '@renter-hub/auth/RenterAuthProvider';

type AppRoutesProps = {
  isLandlordAuthReactEnabled: boolean;
  isRenterAuthReactEnabled: boolean;
};

export default function AppRoutes({ isLandlordAuthReactEnabled, isRenterAuthReactEnabled }: AppRoutesProps) {
  return (
    <Switch>
      <Route path={BASE_PATHS.RENTAL_MANAGER}>
        <RentalManagerApp enabled={isLandlordAuthReactEnabled} />
      </Route>
      <Route path={BASE_PATHS.RENTER_HUB}>
        <RenterAuthProvider enabled={isRenterAuthReactEnabled}>
          <RenterHubApp />
        </RenterAuthProvider>
      </Route>
      {__DEV__ ? <Route path={BASE_PATHS.DEV_SERVER} component={DevApp} /> : null}
    </Switch>
  );
}
